export function calculateScore(numRight, quizLen, isChallenge) {
  const scoreRatio = numRight / quizLen;
  const challengeQuestionPoints = 15;
  if (isChallenge) {
    return numRight * challengeQuestionPoints;
  }
  return Math.round(scoreRatio * 100);
}
